import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import { Trophy } from 'lucide-react';

export default function Register() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    const result = await register(email, password, name);

    if (result.success) {
      toast.success('Account created successfully!');
      navigate('/admin');
    } else {
      toast.error(result.error);
    }

    setIsLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 hexagram-pattern">
      <div className="w-full max-w-md">
        <div className="glass-card p-8 shadow-2xl">
          <div className="flex flex-col items-center mb-8">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#0038B8] flex items-center justify-center mb-4">
              <Trophy className="w-8 h-8 text-white" />
            </div>
            <h1 className="text-3xl font-bold text-white mb-2">Jesode United Cup 2026</h1>
            <p className="text-[#9BA3AF] text-sm">Create Admin Account</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <Label htmlFor="name" className="text-white mb-2">Full Name</Label>
              <Input
                id="name"
                data-testid="register-name-input"
                type="text"
                value={name}
                onChange={(e) => setName(e.target.value)}
                required
                className="bg-[#0A0F1C] border-white/20 text-white"
                placeholder="John Doe"
              />
            </div>

            <div>
              <Label htmlFor="email" className="text-white mb-2">Email</Label>
              <Input
                id="email"
                data-testid="register-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="bg-[#0A0F1C] border-white/20 text-white"
                placeholder="admin@example.com"
              />
            </div>

            <div>
              <Label htmlFor="password" className="text-white mb-2">Password</Label>
              <Input
                id="password"
                data-testid="register-password-input"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="bg-[#0A0F1C] border-white/20 text-white"
                placeholder="••••••••"
              />
            </div>

            <Button
              type="submit"
              data-testid="register-submit-button"
              disabled={isLoading}
              className="w-full bg-[#D4AF37] hover:bg-[#F3E5AB] text-[#0A0F1C] font-bold h-12"
            >
              {isLoading ? 'Creating account...' : 'Create Account'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="text-[#9BA3AF] text-sm">
              Already have an account?{' '}
              <Link to="/login" className="text-[#D4AF37] hover:text-[#F3E5AB] font-semibold">
                Login
              </Link>
            </p>
          </div>

          <div className="mt-4 text-center">
            <Link to="/" className="text-[#0038B8] hover:text-[#D4AF37] text-sm font-semibold">
              ← Back to Home
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}